module.exports = __webpack_public_path__ + "static/media/bdm-icons.53ff4acd.woff";